import React, { useRef } from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

// Because the React Query devtools default to loading in `development`,
// this code is necessary to allow it to build/bundle in `hot` for us.
// The condition makes sure the code isn't bundled in the production build.
// IMPORTANT: Also check for browser environment to avoid bundling in SSR
let ReactQueryDevtools = () => null;
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  ReactQueryDevtools =
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('@tanstack/react-query-devtools/build/lib/index.prod.js').ReactQueryDevtools;
}

export const ReactQueryProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const queryClient = useRef(new QueryClient());
  const showDevtools =
    typeof window !== 'undefined' && localStorage.devtools === 'true';

  return (
    <QueryClientProvider client={queryClient.current}>
      {children}

      {showDevtools && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
};
